import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@google/model-viewer'
import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
